/**
 * OrbDocTutorialsIntermediateCrossOrbitalARDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocTutorialsIntermediateCrossOrbitalARDocScreen
 */

import { useOrbDocTutorialsIntermediateCrossOrbitalARDocScreenLogic } from '@/hooks/traits/useOrbDocTutorialsIntermediateCrossOrbitalARDocScreenLogic';
import type { OrbDocTutorialsIntermediateCrossOrbitalARDocScreenConfig } from '@/hooks/traits/useOrbDocTutorialsIntermediateCrossOrbitalARDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocTutorialsIntermediateCrossOrbitalARDocView as OrbDocTutorialsIntermediateCrossOrbitalARDocViewEntity } from '@app/shared';
import { OrbDocTutorialsIntermediateCrossOrbitalARDocBodyView } from '@/components/traits/OrbDocTutorialsIntermediateCrossOrbitalARDocBodyView';
import { OrbDocTutorialsIntermediateCrossOrbitalARDocFooterView } from '@/components/traits/OrbDocTutorialsIntermediateCrossOrbitalARDocFooterView';
import { OrbDocTutorialsIntermediateCrossOrbitalARDocHeaderView } from '@/components/traits/OrbDocTutorialsIntermediateCrossOrbitalARDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocTutorialsIntermediateCrossOrbitalARDocScreenViewProps {
  config?: Partial<OrbDocTutorialsIntermediateCrossOrbitalARDocScreenConfig>;
}

export function OrbDocTutorialsIntermediateCrossOrbitalARDocScreenView({ config: propsConfig }: OrbDocTutorialsIntermediateCrossOrbitalARDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocTutorialsIntermediateCrossOrbitalARDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocTutorialsIntermediateCrossOrbitalARDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocTutorialsIntermediateCrossOrbitalAR" trait="OrbDocTutorialsIntermediateCrossOrbitalARDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocTutorialsIntermediateCrossOrbitalARDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocTutorialsIntermediateCrossOrbitalARDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsIntermediateCrossOrbitalARDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsIntermediateCrossOrbitalARDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocTutorialsIntermediateCrossOrbitalARDocScreenView;
